import 'bootstrap'
import '@fancyapps/fancybox'
import '../styles/style.scss'
import reveal from './scripts/reveal'
import wishlist from './scripts/wishlist'
import eligibility, { eligibilityTooltip } from './scripts/eligibility'
import authModal from './scripts/auth-modal'
import { campusesList } from './scripts/campuses-list'
import { logoSlider } from './scripts/logo-slider'
import embeddedMap from './scripts/embedded-map'
import showOnMap from './scripts/show_on_map'
import showOnMapPage from './scripts/show_on_map_page'
import studyItemCarousel from "./scripts/study-item-carousel";
import showOnMapPageClick from "./scripts/show_on_map_page_click";
import showPrograms from "./scripts/show_programs";
import groupedRows from "./scripts/grouped-rows";
import socialModal from "./scripts/social";
import additionalCostModal from "./scripts/additional-cost";
import startDatesModal from "./scripts/start-dates";
import { statsInit } from "./scripts/stats";
import { loader } from './scripts/loader';
import store from './scripts/simplestore';
import ranking_info_window from './scripts/ranking';
import featured_info_window from './scripts/featured';
import { apply, applyTooltip } from './scripts/apply';
import { emojiTooltip } from './scripts/emoji';
import { init_request_form } from "./request_info_form";
import { init_ambassador_contact_form } from "./ambassador_contact_form";
import { init_testimonial_school_form } from "./testimonial_school_form";

$('[data-fancybox="gallery"]').fancybox();
eligibilityTooltip();
applyTooltip();
emojiTooltip();

reveal()
wishlist()
eligibility()
ranking_info_window()
featured_info_window()
authModal()
campusesList.init()
logoSlider()
showOnMap()
showOnMapPage()
embeddedMap()
studyItemCarousel()
showOnMapPageClick()
showPrograms()
statsInit()
groupedRows()
socialModal()
additionalCostModal()
startDatesModal()
apply()
init_request_form()
init_ambassador_contact_form()
init_testimonial_school_form()

$(document).on('click', '.student-mode-exit', function (e) {
  e.preventDefault();
  const type = $(this).data('mode-type');
  if (type === '') {
    return false;
  }

  let action = '';
  let nonce = '';

  if (type === 'counselor') {
    action = 'counselor_exit_student_mode';
    nonce = window.glob_obj.counselor_exit_student_mode_nonce;
  }

  if (type === 'agent') {
    action = 'agent_exit_student_mode';
    nonce = window.glob_obj.agent_exit_student_mode_nonce;
  }

  $.ajax({
    url: window.glob_obj.ajaxurl,
    method: 'POST',
    dataType: 'json',
    data: {
      action: action,
      _ajax_nonce: nonce
    },
    beforeSend: function () {
      loader.show()
    },
    success: function (response) {
      if (response.success) {
        window.location = response.redirect
      }
    },
    error: function (error) {
      loader.hide()
      console.log(error);
    }
  });
});
$(document).on('click', '.school-mode-exit', function (e) {
  e.preventDefault();

  $.ajax({
    url: window.glob_obj.ajaxurl,
    method: 'POST',
    dataType: 'json',
    data: {
      action: 'agent_exit_school_mode',
      _ajax_nonce: window.glob_obj.agent_exit_school_mode_nonce
    },
    beforeSend: function () {
      loader.show()
    },
    success: function (response) {
      if (response.success) {
        window.location = response.redirect
      }
    },
    error: function (error) {
      loader.hide()
      console.log(error);
    }
  });
});
$(document).on('click', '.agent-mode-exit', function (e) {
  e.preventDefault();

  $.ajax({
    url: window.glob_obj.ajaxurl,
    method: 'POST',
    dataType: 'json',
    data: {
      action: 'agent_exit_agent_mode',
      _ajax_nonce: window.glob_obj.agent_exit_agent_mode_nonce
    },
    beforeSend: function () {
      loader.show()
    },
    success: function (response) {
      if (response.success) {
        window.location = response.redirect
      }
    },
    error: function (error) {
      loader.hide()
      console.log(error);
    }
  });
});
$(document).on('click', '.counselor-mode-exit', function (e) {
  e.preventDefault();

  $.ajax({
    url: window.glob_obj.ajaxurl,
    method: 'POST',
    dataType: 'json',
    data: {
      action: 'agent_exit_counselor_mode',
      _ajax_nonce: window.glob_obj.agent_exit_counselor_mode_nonce
    },
    beforeSend: function () {
      loader.show()
    },
    success: function (response) {
      if (response.success) {
        window.location = response.redirect
      }
    },
    error: function (error) {
      loader.hide()
      console.log(error);
    }
  });
});
$(document).on('click', '.btn-chat', function (e) {
  e.preventDefault();

  const schoolId = $(this).data('school-id');
  const productId = $(this).data('product-id');

  const chatAccessModal = `
    <div class="modal fade chat-access-modal" tabindex="-1" role="dialog" id="chat-access-modal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-close-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            </div>
          <div class="modal-body">
            You can contact the school once you start an application. 
            ${productId !== undefined ? `<br/>Click <a style="color: #2ba1c6;" href="/cart/?add-to-cart=${productId}">Apply</a> to continue.` : ''}
          </div>
          <div class="modal-footer" style="margin: 20px 0 0 0; padding: 0; border: 0;">
            <button type="button" class="btn btn-primary" data-dismiss="modal" style="margin: 0 auto;padding: 7px 21px;">Close</button>
          </div>
        </div>
      </div>
    </div>
    `;

  $.ajax({
    url: window.glob_obj.ajaxurl,
    method: 'POST',
    dataType: 'json',
    data: {
      action: 'aw_open_chat_room',
      school_id: schoolId,
      _ajax_nonce: window.glob_obj.aw_open_chat_room_nonce
    },
    beforeSend: function () {
      loader.show()
    },
    success: function (response) {
      if (response.success === 1) {
        window.location = response.redirect
      } else {
        loader.hide();
      }
      if (response.success === 0) {
        $('body').append(chatAccessModal);
        $('#chat-access-modal').modal().on('hidden.bs.modal', function (e) {
          $(this).remove();
        });
      }
    },
    error: function (error) {
      loader.hide()
      console.log(error);
    }
  });
});
$(document).on('click', '.btn-chat-school', function (e) {
  e.preventDefault();

  $.ajax({
    url: window.glob_obj.ajaxurl,
    method: 'POST',
    dataType: 'json',
    data: {
      action: 'aw_open_chat_room_school',
      user_id: $(this).data('user-id'),
      _ajax_nonce: window.glob_obj.aw_open_chat_room_school_nonce
    },
    beforeSend: function () {
      loader.show()
    },
    success: function (response) {
      if (response.success === 1) {
        window.location = response.redirect
      } else {
        loader.hide();
      }
    },
    error: function (error) {
      loader.hide()
      console.log(error);
    }
  });
});
$(document).on('click', '.btn-chat-agent', function (e) {
  e.preventDefault();

  $.ajax({
    url: window.glob_obj.ajaxurl,
    method: 'POST',
    dataType: 'json',
    data: {
      action: 'aw_open_chat_room_agent',
      user_id: $(this).data('user-id'),
      _ajax_nonce: window.glob_obj.aw_open_chat_room_agent_nonce
    },
    beforeSend: function () {
      loader.show()
    },
    success: function (response) {
      if (response.success === 1) {
        window.location = response.redirect
      } else {
        loader.hide();
      }
    },
    error: function (error) {
      loader.hide()
      console.log(error);
    }
  });
});
$(document).on('click', '.btn-chat-counselor', function (e) {
  e.preventDefault();

  $.ajax({
    url: window.glob_obj.ajaxurl,
    method: 'POST',
    dataType: 'json',
    data: {
      action: 'aw_open_chat_room_counselor',
      user_id: $(this).data('user-id'),
      _ajax_nonce: window.glob_obj.aw_open_chat_room_counselor_nonce
    },
    beforeSend: function () {
      loader.show()
    },
    success: function (response) {
      if (response.success === 1) {
        window.location = response.redirect
      } else {
        loader.hide();
      }
    },
    error: function (error) {
      loader.hide()
      console.log(error);
    }
  });
});

$(document).on("click", ".ipeds-link", function (e) {
  e.preventDefault();
  const url = $(this).data("url");
  window.open(url, "popup", "width=1000,height=800");
});

(function ($) {
  'use strict';

  $(".tab-content").on("mouseenter", function (e) {
    $('.docs-tooltip__help').each(function () {
      if ($(this).offset().left + 170 >= $(document).width()) {
        $(this).addClass('align-right')
      }
    })
  });
  $('.cart-continue-browsing').attr('href', () => {
    const v = store('search-url');
    return v ? v : '/schools';
  });

})(jQuery);

/**
 * Add gtag after user click apply checkout button
 */
$(document).on('click', '.apw_woocommerce-checkout-review-order #place_order', function (e) {
  loader.show()
  $(document).find('.woocommerce-NoticeGroup-checkout').remove()
  // window.gtag('event', 'conversion', { 'send_to': 'AW-10838494460/efW7CJ_ejJADEPyZmbAo', 'value': 1.0, 'currency': 'USD' });
});

$(".my_applications_page_checkout_form").bind("DOMSubtreeModified", function () {
  if ($(this).find('.woocommerce-NoticeGroup-checkout').length > 0) {
    loader.hide()
  }
});


// https://getbootstrap.com/docs/4.6/components/collapse/#events
$('.collapse').on('hide.bs.collapse', function () {
  const id = $(this).attr('id');
  $(`#${id}-icon`).find('img').css('transform', 'rotate(-90deg)');
}).on('show.bs.collapse', function () {
  const id = $(this).attr('id');
  $(`#${id}-icon`).find('img').css('transform', 'rotate(90deg)');

  const initType = $(this).data('init-type');
  if (initType === 'slider') {
    $(this).find('.slk-study-item-slider').slick('refresh');
  }
  if (initType === 'map' && window.mymap) {
    window.mymap.off();
    window.mymap.remove();
    embeddedMap();
  }
});